export const SIDE_PANEL_OPEN = '@sidePanels/SIDE_PANEL_OPEN';
export const SIDE_PANEL_CLOSE = '@sidePanels/SIDE_PANEL_CLOSE';
export const CONTACT_SIDE_PANEL_CLOSE = '@sidePanels/CONTACT_SIDE_PANEL_CLOSE';
export const CONTACT_SIDE_PANEL_OPEN = '@sidePanels/CONTACT_SIDE_PANEL_OPEN';
